import React, { useMemo } from 'react';
import SkeletonHeader from '../SkeletonHeader';
import Card from '../SkeletonCard';
import refreshPic from '../../assets/refresh.png';
import style from './style.scss';
import { I18n } from '@ies/starling_intl';

interface Props {
  isErr: boolean;
  disable: boolean;
  refresh(): void;
}

export default function Skeleton(props: Props) {
  const { isErr, disable, refresh } = props;
  const component = useMemo(() => {
    const list = Array.from({ length: 4 });
    if (isErr) {
      return (
        <div onClick={refresh} className={style.refresh}>
          <img src={refreshPic} className={style.pic} />
          <span className={style.text}>{I18n.t('network_error_click_retry')}</span>
        </div>
      );
    } else if (disable) {
      return (
        <div className={style.refresh}>
          <span className={style.text}>{I18n.t('hashtag_unavailable')}</span>
        </div>
      );
    }
    return (
      <div className={style.wrap}>
        {list.map((_, index) => (
          <Card key={index} />
        ))}
      </div>
    );
  }, [isErr, disable]);

  return (
    <div className={style.skeleton}>
      <SkeletonHeader />
      {component}
    </div>
  );
}
